import * as React from 'react';
import styled from 'styled-components';
import { IBaseComponentProps } from '../../types';

interface IPopupContentProps extends IBaseComponentProps<HTMLDivElement> {
    clientHeight: number;
    doesFooterExists?: boolean;
    onRenderContent(): React.ReactNode;
}

function PopupContentBase(props: IPopupContentProps) {
    const { onRenderContent, className } = props;
    return (
        <div className={className}>
            {onRenderContent()}
        </div>
    );
}

function getMaxHeight(clientHeight: number, doesFooterExists?: boolean) {
    return doesFooterExists ? ((clientHeight * 0.7) - 120) : ((clientHeight * 0.9) - 70);
}

export const PopupContent = styled(PopupContentBase).attrs(() => ({
    className: String('ap-popup-content')
}))`
    box-sizing: border-box;
    position: relative;
    height: auto;
    max-height: ${({ doesFooterExists, clientHeight }) => getMaxHeight(clientHeight, doesFooterExists)}px;
    overflow: auto;
    flex: auto;
`;
